import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

const DIRECTIVE_LIST = [];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: DIRECTIVE_LIST,
  exports: DIRECTIVE_LIST
})
export class StyleDirectivesModule { }
